export const SUBSCRIPTION_SETTINGS_URL = '/settings/subscriptions'
export const NOTIFICATIONS_URL = '/member/notifications'
